import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../../../store';
import Welcome from '../../pages/Welcome';
import VerificationCode from '../../pages/VerificationCode';
import ResendVerification from '../../pages/ResendVerification';
import NotFinishingSignUp from '../../pages/NotFinishingSignUp';
import Take5 from '../../pages/Take5';
import TookABreak from '../../pages/TookABreak';
import Help from '../../pages/Help';
import { DEFAULT_VIEWS_BY_ROLE, VIEWS_MAP } from '../../../../router/constants';
import { getCookie, setCookie } from '../../../../helpers';
import bugsnagHandler from '../../../../services/bugsnag.service';
import { TempPassword } from '../../pages/TempPassword';
import { LOGIN_NAVIGATION_MAP } from './constants';

const LoginNavigation = () => {
  const {
    currentPage, setCurrentPage, setUser, summary,
  } = useStore(state => state);
  const navigate = useNavigate();

  const hydrateMfaData = () => {
    const mfaData: string = getCookie('liliMfaData');
    if (mfaData) {
      let parsedMfaData;
      try {
        parsedMfaData = JSON.parse(mfaData);
        if (!parsedMfaData) return;
        setUser({ ...parsedMfaData });
        setCurrentPage(1);
        setCookie('liliMfaData', 'null', 0, true);
      } catch (e) {
        console.error(e);
        bugsnagHandler.notify(new Error('BalanceUp invalid user state'), (error: any) => {
          error.context = 'Error parsing liliMfaData cookie value';
          error.addMetadata({ mfaData });
        });
      }
    } else if (summary?.customer) {
      if (summary.authorizedUserType) {
        const destinationUrl = DEFAULT_VIEWS_BY_ROLE[summary.authorizedUserType as keyof typeof DEFAULT_VIEWS_BY_ROLE];
        navigate(destinationUrl);
      } else {
        navigate(`/${VIEWS_MAP.DASHBOARD}`);
      }
    }
  };

  useEffect(() => {
    hydrateMfaData();
  }, []);

  const renderSwitch = () => {
    switch (currentPage) {
      case 1:
        return <VerificationCode />;
      case 2:
        return <ResendVerification />;
      case 3:
        return <NotFinishingSignUp />;
      case 4:
        return <Take5 />;
      case 5:
        return <TookABreak />;
      case 6:
        return <Help />;
      case LOGIN_NAVIGATION_MAP.PASSWORD_EXPIRED:
        return <TempPassword />;
      default:
        return <Welcome />;
    }
  };
  if (currentPage === null) {
    return null;
  }

  return renderSwitch();
};

export default LoginNavigation;
